export const getFirstInitial = (name) => name.charAt(0);
